// extracted by css-extract-rspack-plugin
export default {"barTooltipLabel":"barTooltipLabel-lRwdzL","barTooltipValue":"barTooltipValue-_IWL1M"};